/**
 * Contatti ufficio tecnico per notifiche segnalazioni degrado.
 * In produzione: API comune / registro istituzionale.
 */

import { getAmbasciatoreLabel } from "./borgoPaginaTemplateData";

const UFFICIO_BY_SLUG = {
  campli: { email: "ufficio.tecnico@comune.campli.it", telefono: null, referente: "Ufficio Tecnico · Comune di Campli" },
  crognaleto: { email: "tecnico@comune.crognaleto.it", telefono: null, referente: "Ufficio Tecnico · Crognaleto" },
  atri: { email: "lavori.pubblici@comune.atri.it", telefono: null, referente: "Lavori Pubblici · Atri" },
  montorio: { email: "tecnico@comune.montorio.it", telefono: null, referente: "Ufficio Tecnico · Montorio al Vomano" },
  teramo: { email: "patrimonio@comune.teramo.it", telefono: null, referente: "Patrimonio · Comune di Teramo" },
};

const DEFAULT_EMAIL_DOMAIN = "protocollo.6amico.it";

export function getUfficioTecnicoContact(comuneSlug, comuneName) {
  const slug = (comuneSlug || "").toLowerCase();
  const specific = UFFICIO_BY_SLUG[slug];
  if (specific) {
    return {
      ...specific,
      ambasciatore: getAmbasciatoreLabel(slug),
      comuneSlug: slug,
      comuneName: comuneName || slug,
    };
  }
  const label = comuneName || slug || "borgo";
  return {
    email: `tutela+${slug || "generico"}@${DEFAULT_EMAIL_DOMAIN}`,
    telefono: null,
    referente: `Ufficio Tecnico · ${label}`,
    ambasciatore: getAmbasciatoreLabel(slug),
    comuneSlug: slug,
    comuneName: label,
    demo: true,
  };
}
